var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "inner-card", style: { background: _vm.backgroundColor } },
    [
      _c("loading", {
        attrs: {
          active: _vm.isLoading,
          "enforce-focus": false,
          loader: "dots",
        },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("ValidationObserver", {
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ handleSubmit }) {
              return [
                _c(
                  "div",
                  { staticClass: "row" },
                  [
                    _c("div", { staticClass: "col-md-6" }, [
                      _c(
                        "div",
                        { staticClass: "field" },
                        [
                          _c("ValidationProvider", {
                            attrs: { rules: "required" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function ({ errors }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "field-title" },
                                        [
                                          _c("span", { staticClass: "mark" }, [
                                            _vm._v("*"),
                                          ]),
                                          _c(
                                            "span",
                                            { style: { color: _vm.fontColor } },
                                            [
                                              _vm._v(
                                                " 本人是否與其他公司簽訂競業禁止條款？ "
                                              ),
                                              _c(
                                                "p",
                                                { staticClass: "en-text" },
                                                [
                                                  _vm._v(
                                                    " Have I signed a non-competition clause with other companies? "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "field-radio" },
                                        [
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.HasNCC,
                                                  expression: "HasNCC",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: true,
                                                checked: _vm._q(
                                                  _vm.HasNCC,
                                                  true
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.HasNCC = true
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("是 (Yes)")]),
                                          ]),
                                          _c("label", [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.HasNCC,
                                                  expression: "HasNCC",
                                                },
                                              ],
                                              attrs: { type: "radio" },
                                              domProps: {
                                                value: false,
                                                checked: _vm._q(
                                                  _vm.HasNCC,
                                                  false
                                                ),
                                              },
                                              on: {
                                                change: function ($event) {
                                                  _vm.HasNCC = false
                                                },
                                              },
                                            }),
                                            _c("span", [_vm._v("否 (No)")]),
                                          ]),
                                        ]
                                      ),
                                      errors[0]
                                        ? _c(
                                            "span",
                                            { staticClass: "text-danger" },
                                            [
                                              _vm._v(
                                                " " + _vm._s(errors[0]) + " "
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ]),
                    _c("div", { staticClass: "col-md-6" }),
                    _vm._l(_vm.nonCompete, function (item, index) {
                      return [
                        _c(
                          "div",
                          { key: "Company" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 所負義務對象（與您約定競業禁止的公司） "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [_vm._v("Company's name")]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Company,
                                                      expression:
                                                        "item.Company",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Company,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Company",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "District" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 競業禁止區域 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Non competition restrictions"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.District,
                                                      expression:
                                                        "item.District",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "『例如：台北市、新北市、新竹市』",
                                                    maxlength: "50",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.District,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "District",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "StartDate" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 競業禁止期間（起） "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Time for non-competition (Start) "
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "YYYY-MM-DD",
                                                  },
                                                  model: {
                                                    value: item.StartDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "StartDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.StartDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "EndDate" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: {
                                    rules: {
                                      required: true,
                                      notBeforeStartDate: item.StartDate,
                                    },
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      " 競業禁止期間（迄） "
                                                    ),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Time for non-competition (End)"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("el-date-picker", {
                                                  staticClass: "w-100",
                                                  attrs: {
                                                    type: "date",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder: "YYYY-MM-DD",
                                                  },
                                                  model: {
                                                    value: item.EndDate,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "EndDate",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "item.EndDate",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Scope" + index, staticClass: "col-md-6" },
                          [
                            _c(
                              "div",
                              { staticClass: "field" },
                              [
                                _c("ValidationProvider", {
                                  attrs: { rules: "required" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function ({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "field-title" },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "mark" },
                                                  [_vm._v("*")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    style: {
                                                      color: _vm.fontColor,
                                                    },
                                                  },
                                                  [
                                                    _vm._v(" 競業禁止範圍 "),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass: "en-text",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "Non competition restrictions"
                                                        ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "div",
                                              { staticClass: "field-value" },
                                              [
                                                _c("input", {
                                                  directives: [
                                                    {
                                                      name: "model",
                                                      rawName: "v-model",
                                                      value: item.Scope,
                                                      expression: "item.Scope",
                                                    },
                                                  ],
                                                  attrs: {
                                                    type: "text",
                                                    placeholder:
                                                      "『例如：半導體設計業』",
                                                    maxlength: "200",
                                                    autocomplete: "off",
                                                    readonly: "",
                                                  },
                                                  domProps: {
                                                    value: item.Scope,
                                                  },
                                                  on: {
                                                    focus: function ($event) {
                                                      return _vm.$common.removeReadonly(
                                                        $event
                                                      )
                                                    },
                                                    input: function ($event) {
                                                      if (
                                                        $event.target.composing
                                                      )
                                                        return
                                                      _vm.$set(
                                                        item,
                                                        "Scope",
                                                        $event.target.value
                                                      )
                                                    },
                                                  },
                                                }),
                                              ]
                                            ),
                                            errors[0]
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "text-danger",
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(errors[0]) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          { key: "Remark" + index, staticClass: "col-md-6" },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [
                                    _vm._v(" 其他備註說明事項 "),
                                    _c("span", { staticClass: "en-text" }, [
                                      _vm._v("Remark"),
                                    ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "field-value" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: item.Remark,
                                      expression: "item.Remark",
                                    },
                                  ],
                                  attrs: {
                                    type: "text",
                                    placeholder:
                                      "『請補充說明競業禁止條款其他有關事項（如有）』",
                                    maxlength: "200",
                                    autocomplete: "off",
                                    readonly: "",
                                  },
                                  domProps: { value: item.Remark },
                                  on: {
                                    focus: function ($event) {
                                      return _vm.$common.removeReadonly($event)
                                    },
                                    input: function ($event) {
                                      if ($event.target.composing) return
                                      _vm.$set(
                                        item,
                                        "Remark",
                                        $event.target.value
                                      )
                                    },
                                  },
                                }),
                              ]),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ContractDesc" + index,
                            staticClass: "col-md-12",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [_vm._v(" 如無法提供，請說明原因 ")]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      type: "textarea",
                                      rows: 3,
                                      maxlength: "200",
                                      "show-word-limit": "",
                                    },
                                    model: {
                                      value: item.ContractDesc,
                                      callback: function ($$v) {
                                        _vm.$set(item, "ContractDesc", $$v)
                                      },
                                      expression: "item.ContractDesc",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _c(
                          "div",
                          {
                            key: "ContractFileGroupGuid" + index,
                            staticClass: "col-md-6",
                          },
                          [
                            _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-title" }, [
                                _c(
                                  "span",
                                  { style: { color: _vm.fontColor } },
                                  [_vm._v(" 請上傳競業禁止合約 ")]
                                ),
                              ]),
                              _c(
                                "div",
                                { staticClass: "field-value" },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo w-100",
                                      attrs: {
                                        action: "",
                                        "auto-upload": false,
                                        "show-file-list": false,
                                        "on-change": _vm.uploadFile,
                                      },
                                      model: {
                                        value: item.ContractFileGroupGuid,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            item,
                                            "ContractFileGroupGuid",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "item.ContractFileGroupGuid",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          staticStyle: { "margin-top": "5px" },
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.dataIndex = index
                                            },
                                          },
                                        },
                                        [_vm._v(" 點擊上傳 ")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]),
                            _vm._l(
                              item.ContractFiles,
                              function (file, fileIndex) {
                                return _c("div", { key: file.FileGuid }, [
                                  _c(
                                    "p",
                                    { staticStyle: { "margin-top": "-10px" } },
                                    [
                                      _c("eva-icon", {
                                        attrs: {
                                          fill: "#5b5b5b",
                                          name: "attach-outline",
                                        },
                                      }),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "15px",
                                            "vertical-align": "text-top",
                                            cursor: "default",
                                            color: "#5b5b5b",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " + _vm._s(file.FileName) + " "
                                          ),
                                        ]
                                      ),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            display: "inline-block",
                                            position: "absolute",
                                            right: "15px",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              _vm.removeFile(
                                                {
                                                  fileGuid: file.FileGuid,
                                                  fileIndex: fileIndex,
                                                },
                                                (_vm.dataIndex = index)
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("eva-icon", {
                                            attrs: {
                                              fill: "#5b5b5b",
                                              name: "trash-2-outline",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ])
                              }
                            ),
                          ],
                          2
                        ),
                        _vm.nonCompete.length > 1
                          ? _c(
                              "div",
                              {
                                key: "button" + index,
                                staticClass: "col-md-6",
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "del-btn",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.del(index)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(_vm.$t("BUTTON.RESUME_DELETE")) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    }),
                  ],
                  2
                ),
                _c("div", { staticClass: "edit-btn-wrap" }, [
                  _vm.HasNCC
                    ? _c(
                        "button",
                        {
                          staticClass: "btn-sm add-btn",
                          attrs: { type: "button" },
                          on: { click: _vm.add },
                        },
                        [
                          _vm._v(
                            " " + _vm._s(_vm.$t("BUTTON.RESUME_ADD")) + " "
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "button",
                    {
                      staticClass: "put-btn",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return handleSubmit(_vm.saveNCC)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("BUTTON.RESUME_SAVE")) + " ")]
                  ),
                ]),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }